import { Rescatable } from '../Rescatable';

export class Faqs extends Rescatable {
  static _name = 'Faqs';
  static pathRequest = `${Rescatable.pathRequestStatic}preguntas`;
  static pk: keyof Faqs = 'id';
  id: number;
  id_ayuda_pregunta_padre: number;
  id_unidad: number;
  problema: string;
  ayuda_html: string;
  icono?: string;
  activo: boolean;
  usuario_requerido: boolean;
  evaluacion_requerida: boolean;
  nombre_btn_envio: string;
  valorizacion_positiva: number;
  valorizacion_negativa: number;
  envio_pregunta_requerida: boolean;
  orden: number;
  tipo_icono: string;
  fecha_alta: string;
  $padre: Faqs;
  $hijos: Faqs[];
  constructor(element: Faqs) {
    super(element);
  }
}
